const X_API_KEY = 'JvW8fUiuMtfbtxmktopbHacJuh54QVkSReaTx6kQHodnC8TTlAQZZ6KKMAAuyGPQV3Da1Ivw';

const appConfig = {
  freewheel: {
    networkId: "174057",
    dashProfile: "c4_hd_html5_dash_live",
    hlsProfile: "c4_hd_html5_hls_live",
    profileIdWeb: "http://www.channel4.com/4od",
    profileIdWebiOs: "ios.browser.channel4.com/4od",
    profileIdWebAndroid: "android.browser.channel4.com/4od",
  },
};

export async function fetchSource(url, opts = {}) {
  const { preferYospace = false } = opts;
  if (!url) throw new Error("Missing url");

  try {
    const res = await fetch(url, {
      cache: "no-store",
      headers: {
        "X-Api-Key": X_API_KEY,
      },
    });

    if (!res.ok) {
      throw new Error("Failed to fetch");
    }

    const data = await res.json();
    const playerSource = {};

    const { video } = data.resultObj || {};

    const dash = video["dash-iso"] || {};
    const hls = video["hls"] || {};
    // Helper: choose stream_url vs yospace_url
    const pickUrl = (dashUrl, yospaceUrl) => {
      if (preferYospace && yospaceUrl) return yospaceUrl;
      return dashUrl;
    };

    if (dash.stream_url) {
      const { la_url = {}, stream_url = "", yospace_url = "" } = dash;
      const headers = { "X-Api-Key": X_API_KEY };

      playerSource.dash = pickUrl(stream_url, yospace_url);
      playerSource.drm = playerSource.drm || {};

      if (la_url.widevine)
        playerSource.drm.widevine = { LA_URL: la_url.widevine, headers };
      if (la_url.playready)
        playerSource.drm.playready = { LA_URL: la_url.playready, headers };
    }

    if (hls.stream_url) {
      const { certificate = {}, la_url = {}, stream_url, yospace_url } = hls;
      const headers = { "X-Api-Key": X_API_KEY };

      playerSource.hls = pickUrl(stream_url, yospace_url);
      playerSource.drm = playerSource.drm || {};

      if (la_url.fairplay)
        playerSource.drm.fairplay = {
          LA_URL: la_url.fairplay,
          certificateURL: certificate.fairplay,
          headers,
          prepareMessage: (event, session) => {
            const assetId = session.contentId;
            const spcData = event.messageBase64Encoded;

            const messageBody = `spc=${spcData}&assetId=${
              assetId.split("//")[1]
            }`;

            return messageBody;
          },
          prepareCertificate: (data) => {
            return data;
          },
          prepareLicense(data) {
            return data;
          },
          prepareContentId: (url) => {
            return url;
          },
        };
    }

    return playerSource;
  } catch (error) {
    throw error;
  }
}

export const API_KEY =
  "JvW8fUiuMtfbtxmktopbHacJuh54QVkSReaTx6kQHodnC8TTlAQZZ6KKMAAuyGPQV3Da1Ivw";
export const DEVICE_INFO_HEADER_KEY = "x-c4-device-info";

/**
 * @typedef {'dotcom'|'dotcom_safari'} Platform
 * @typedef {'mobile'|'tablet'|'desktop'|'big_screen'|'no_screen'} Screen
 * @typedef {'chrome'|'safari'|'firefox'|'edge'|'opera'|'ie'|'unknown'} Browser
 * @typedef {'windows'|'mac'|'linux'|'android'|'ios'|'other'} OS
 *
 * @typedef {Object} DeviceInfo
 * @property {Platform} platform
 * @property {Screen} screen
 * @property {Browser} browser
 * @property {OS} os
 *
 * @typedef {Object} PlayAPIResponse
 * @property {Object} resultObj
 * @property {Object} resultObj.video
 * @property {string} resultObj.video.streamUrl
 * @property {string} resultObj.video.laUrl
 * @property {string=} resultObj.video.certificateUrl
 * @property {Object} resultObj.subtitles
 * @property {string=} resultObj.subtitles['single-web-vtt']
 * @property {any=} resultObj.uiData
 */

function detectBrowser(uaRaw) {
  const ua = (uaRaw || "").toLowerCase();

  if (ua.includes("trident/") || ua.includes("msie")) return "ie";

  if (
    ua.includes("edg/") ||
    ua.includes("edga/") ||
    ua.includes("edgios") ||
    ua.includes("edgios")
  ) {
    return "edge";
  }

  if (ua.includes("opr/") || ua.includes("opera")) return "opera";

  if (ua.includes("firefox/") || ua.includes("fxios")) return "firefox";

  if (ua.includes("chrome/") || ua.includes("crios")) return "chrome";

  const isSafari =
    ua.includes("safari/") &&
    !ua.includes("chrome/") &&
    !ua.includes("crios") &&
    !ua.includes("chromium") &&
    !ua.includes("edg") &&
    !ua.includes("opr/") &&
    !ua.includes("opera");

  if (isSafari) return "safari";

  return "unknown";
}

function detectOS(uaRaw, browser) {
  const ua = (uaRaw ?? '').toLowerCase()

  // ---------- iOS / iPadOS ----------
  const uaHasIPhone = ua.includes('iphone')
  const uaHasIPod = ua.includes('ipod')
  const uaHasIPad = ua.includes('ipad')

  // iPadOS 13+ UA quirk: iPad can appear as Macintosh + Mobile
  const uaIsIpadOsViaMacMobile = ua.includes('macintosh') && ua.includes('mobile')

  // Runtime iPadOS quirk: platform is MacIntel but has touch points
  const isIpadOsViaRuntime =
    typeof navigator !== 'undefined' &&
    (navigator).platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1

  const isIpadOs = uaHasIPad || uaIsIpadOsViaMacMobile || isIpadOsViaRuntime
  if (isIpadOs) return 'ipados'

  const isIos = uaHasIPhone || uaHasIPod || ua.includes('ios') || /cpu (?:iphone )?os \d+/.test(ua) // common iOS pattern
  if (isIos) return 'ios'

  // ---------- Android ----------
  const isAndroid = ua.includes('android')
  if (isAndroid) return 'android'

  // Android-specific browser tokens (helpful when "android" is missing, e.g. odd UA / desktop mode)
  const isEdgeAndroid = browser === 'edge' && (ua.includes('edga') || ua.includes('edga/'))
  if (isEdgeAndroid) return 'android'

  const isFirefoxAndroid = browser === 'firefox' && ua.includes('fennec')
  if (isFirefoxAndroid) return 'android'

  const isSamsungInternetAndroid = ua.includes('samsungbrowser')
  if (isSamsungInternetAndroid) return 'android'

  // If UA says Linux but it’s a touch device, treat as Android (avoid misclassifying Linux desktops)
  const isTouchDevice =
    typeof navigator !== 'undefined' && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0

  const isLinuxTouchLikelyAndroid = ua.includes('linux') && isTouchDevice
  if (isLinuxTouchLikelyAndroid) return 'android'

  // ---------- Desktop OSes ----------
  if (ua.includes('windows')) return 'windows'

  // mac after iPadOS checks above
  if (ua.includes('mac os') || ua.includes('macintosh')) return 'mac'

  // linux after android heuristics above
  if (ua.includes('linux')) return 'linux'

  return 'other'
}

export function detectScreen(ssrUserAgent = '')  {
  const nav = typeof navigator !== 'undefined' ? (navigator) : undefined

  const ua = nav?.userAgent ?? ssrUserAgent
  const platform = nav?.platform ?? ''
  const maxTouchPoints = nav?.maxTouchPoints ?? 0

  const uaDataPlatform = nav?.userAgentData?.platform?.toLowerCase() ?? ''
  const uaDataMobile = nav?.userAgentData?.mobile ?? false

  const isTouchMac = platform === 'MacIntel' && maxTouchPoints > 1

  // Best Android signal on Chromium browsers
  if (uaDataPlatform === 'android') {
    return uaDataMobile ? 'mobile' : 'tablet'
  }

  // iPhone / iPod
  if (/iPhone|iPod/i.test(ua)) {
    return 'mobile'
  }

  // iPad / iPadOS
  if (/iPad/i.test(ua) || isTouchMac) {
    return 'tablet'
  }

  // Android fallback for SSR / non-CH browsers
  if (/Android/i.test(ua)) {
    return /Mobile/i.test(ua) ? 'mobile' : 'tablet'
  }

  return 'desktop'
}

function detectPlatform(browser, platformNames, userAgentRaw = '')  {
  const ua =
    (userAgentRaw && userAgentRaw.trim()) ||
    (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' ? navigator.userAgent : '')

  if (!ua) return browser === 'safari' ? platformNames.platformNameSafari : platformNames.platformName

  const u = ua.toLowerCase()

  const isIpadOs =
    u.includes('ipad') ||
    (u.includes('macintosh') && u.includes('mobile')) ||
    (typeof navigator !== 'undefined' &&
      (navigator).platform === 'MacIntel' &&
      typeof navigator.maxTouchPoints === 'number' &&
      navigator.maxTouchPoints > 1)

  const isIos = /iphone|ipod/.test(u) || u.includes('ios') || /cpu (?:iphone )?os \d+/.test(u)

  const isSafari =
    u.includes('safari') &&
    !u.includes('chrome') &&
    !u.includes('crios') &&
    !u.includes('fxios') &&
    !u.includes('edg') &&
    !u.includes('edgios') &&
    !u.includes('opr') &&
    !u.includes('opios')

  return isIos || isIpadOs || isSafari ? 'dotcom_safari' : 'dotcom'
}

function buildDeviceInfo(userAgent) {
  const browser = detectBrowser(userAgent);
  const os = detectOS(userAgent);
  const screen = detectScreen();
  const platform = detectPlatform(browser);

  return {
    platform,
    screen,
    browser,
    os,
  };
}

/**
 * Convert UA -> header value: "platform=dotcom;screen=desktop;browser=chrome;os=windows;app_version=x"
 * @param {string|undefined} userAgent
 * @returns {string|undefined}
 */
export function deviceInfoToHeader(userAgent) {
  if (!userAgent) return undefined;
  const trimmedUA = String(userAgent).trim();
  const info = buildDeviceInfo(trimmedUA);

  const appVersion =
    typeof process !== "undefined" && process && process.env
      ? process.env.NEXT_PUBLIC_APP_VERSION || "N/A"
      : "N/A";

  const entries = [
    ["platform", info.platform],
    ["screen", info.screen],
    ["browser", info.browser],
    ["os", info.os],
    ["app_version", appVersion],
  ];

  const out = entries
    .filter((pair) => pair && pair[1] != null && pair[1] !== "")
    .map(
      ([key, value]) =>
        `${String(key).toLowerCase()}=${String(value).toLowerCase()}`,
    )
    .join(";");

  return out || undefined;
}

/**
 * Safe timezone getter.
 * @returns {string}
 */
function getTimeZone() {
  return "Europe/London";
}

/**
 * Bitmovin subtitle tracks builder for a single VTT URL.
 * Customize here if you want different label/lang/default behavior.
 * @param {string|undefined} vttUrl
 * @returns {Array<Object>}
 */
function buildSubtitleTracks(vttUrl) {
  if (!vttUrl) return [];
  return [
    {
      url: vttUrl,
      lang: "en",
      label: "English",
      kind: "subtitle",
      mimeType: "text/vtt",
      isDefault: true,
    },
  ];
}

/**
 * Detect whether we should prefer HLS (iOS / iPadOS / Safari on macOS).
 * @param {string} ua
 * @returns {boolean}
 */
export function shouldUseHLS(ua) {
  const u = (ua || "").toLowerCase();

  const isIOS =
    /iphone|ipad|ipod/.test(u) ||
    (u.includes("macintosh") && u.includes("mobile"));
  if (isIOS) return true;

  const isMac = u.includes("macintosh");
  if (!isMac) return false;

  const isSafari =
    u.includes("safari") &&
    !u.includes("chrome") &&
    !u.includes("chromium") &&
    !u.includes("edg") &&
    !u.includes("opr") &&
    !u.includes("fxios") &&
    !u.includes("firefox");

  return isSafari;
}

/**
 * Builds common headers for PLAY API calls (non-example content).
 * @param {string} userAgent
 * @returns {Record<string, string>}
 */
function buildCommonNonExampleHeaders(userAgent) {
  const headers = {};

  headers["X-Device-Timezone"] = getTimeZone();
  headers[DEVICE_INFO_HEADER_KEY] = deviceInfoToHeader(userAgent) || "";

  return headers;
}

/**
 * Fetch JSON with headers.
 * @template T
 * @param {string} url
 * @param {Record<string, string>} headers
 * @returns {Promise<T>}
 */
async function fetchJson(url, headers) {
  const res = await fetch(url, { headers, cache: "no-store", credentials: 'include' });
  if (!res.ok) throw new Error(`API ${res.status}`);
  return /** @type {Promise<any>} */ (res.json());
}

/**
 * Guarded FairPlay prepareMessage.
 * @param {any} event
 * @param {any} session
 * @returns {string}
 */
function fairplayPrepareMessage(event, session) {
  const assetId = session && session.contentId;
  const spcData = event && event.messageBase64Encoded;

  if (!assetId) throw new Error("FairPlay: missing session.contentId");
  if (!spcData) throw new Error("FairPlay: missing event.messageBase64Encoded");

  const parts = String(assetId).split("//");
  const assetIdValue = parts && parts[1];
  if (!assetIdValue)
    throw new Error(
      `FairPlay: unexpected contentId format: ${String(assetId)}`,
    );

  return `spc=${spcData}&assetId=${assetIdValue}`;
}

/**
 * Build Bitmovin SourceConfig from PLAY API response (DASH/Widevine OR HLS/FairPlay).
 * @param {PlayAPIResponse} json
 * @param {string} userAgent
 * @returns {{ srcCfg: any, uiData: any }}
 */
function buildPlaySourceConfig(json, userAgent, useYospace) {
  const resultObj = json && json.resultObj;
  const video = resultObj && resultObj.video;
  const subtitles = resultObj && resultObj.subtitles;
  const uiData = resultObj && resultObj.uiData;

  if (!video || !video.streamUrl)
    throw new Error("No streamUrl in API response");

  const vtt = subtitles && subtitles["single-web-vtt"];
  const subtitleTracks = buildSubtitleTracks(vtt);

  const commonNonExampleHeaders = buildCommonNonExampleHeaders(userAgent);
  const useHLS = shouldUseHLS(userAgent);
const streamUrl = useYospace && video?.yospace_url  ? video?.yospace_url : video?.streamUrl
  const srcCfg = useHLS
    ? {
        hls: streamUrl,
        drm: video.laUrl
          ? {
              fairplay: {
                LA_URL: video.laUrl,
                certificateURL: video.certificateUrl,
                prepareMessage: fairplayPrepareMessage,
                prepareCertificate: (data) => data,
                prepareLicense: (data) => data,
                prepareContentId: (url) => url,
                headers: {
                  "X-Api-Key": API_KEY,
                  [DEVICE_INFO_HEADER_KEY]: deviceInfoToHeader(userAgent) || "",
                },
              },
            }
          : undefined,
        subtitleTracks,
      }
    : {
        dash: streamUrl,
        drm: video.laUrl
          ? {
              widevine: {
                LA_URL: video.laUrl,
                 withCredentials: true,
                headers: {
                  "X-Api-Key": API_KEY,
                  ...commonNonExampleHeaders,
                },
              },
            }
          : undefined,
        subtitleTracks,
      };

  return { srcCfg, uiData: uiData != null ? uiData : null };
}

/**
 * Main API: fetch source config for Bitmovin player.
 *
 * @param {string} contentUri - PLAY endpoint (e.g. https://play.videosolutionhub.com/PLAY/VOD/1234)
 * @param {Object=} options
 * @param {string=} options.userAgent - override for tests / SSR
 * @returns {Promise<any>} Bitmovin SourceConfig
 */
export async function fetchPlayApiSource(contentUri, useYospace = false) {
  if (!API_KEY || API_KEY === "REPLACE_ME") {
    throw new Error("fetchSource.js: set API_KEY at the top of the file");
  }

  const commonNonExampleHeaders = buildCommonNonExampleHeaders(
    navigator.userAgent,
  );

  const headers = {
    "X-Api-Key": API_KEY,
    ...commonNonExampleHeaders,
  };

  const json = await fetchJson(contentUri, headers);
  const { srcCfg } = buildPlaySourceConfig(json, navigator.userAgent, useYospace);
  const ads = buildAdConfig(json)

  return { srcCfg, ads };
}

export function getUserAgent() {
  return typeof navigator !== "undefined" ? navigator.userAgent : "";
}

function buildAdConfig(json) {
  const ua = getUserAgent();
  const adsUrlTemplate = json?.resultObj?.ads?.url;
  const vmapUrl = adsUrlTemplate
    ? buildFreewheelVmapUrl(adsUrlTemplate, appConfig, ua)
    : null;

  const adBreak = vmapUrl
    ? {
        discardAfterPlayback: false,
        id: "fw-vmap-main",
        position: "pre",
        tag: {
          type: "vmap",
          url: vmapUrl,
        },
      }
    : null;
  return adBreak;
}

function buildFreewheelVmapUrl(templateUrl, appConfig, userAgent) {
  let url = decodeURIComponent(templateUrl).replaceAll(
    "{fwNetworkId}",
    appConfig.freewheel.networkId,
  );

  // TODO: temporary fix to empty ads issue on certain UA's
  // Remove this once issue is fixed in the 174057 network
  url = url.replace("nw=174057", "nw=174055");

  url = url.replaceAll(
    "{fwProfile}",
    shouldUseHls(userAgent)
      ? appConfig.freewheel.hlsProfile
      : appConfig.freewheel.dashProfile,
  );

  const profileId = getFreewheelProfileId(userAgent, appConfig);
  url = url.replaceAll("{fwProfileId}", profileId);

  return url;
}

function getFreewheelProfileId(userAgent, appConfig) {
  const ua = userAgent ?? "";
  if (isIos(ua)) return appConfig.freewheel.profileIdWebiOs;
  if (isAndroid(ua)) return appConfig.freewheel.profileIdWebAndroid;
  return appConfig.freewheel.profileIdWeb;
}

function shouldUseHls(userAgent) {
  const u = (userAgent ?? "").toLowerCase();

  const isiOSLike =
    /iphone|ipad|ipod/.test(u) ||
    (u.includes("macintosh") && u.includes("mobile"));
  if (isiOSLike) return true;

  const isMac = u.includes("macintosh");
  if (!isMac) return false;

  const isSafari =
    u.includes("safari") &&
    !u.includes("chrome") &&
    !u.includes("chromium") &&
    !u.includes("edg") &&
    !u.includes("opr") &&
    !u.includes("fxios") &&
    !u.includes("firefox");

  return isSafari;
}

export function isIpadOs(ua, nav) {
  const n = nav ?? (typeof navigator !== "undefined" ? navigator : undefined);
  const uaChPlatform = n?.userAgentData?.platform;

  const looksLikeMac =
    /Macintosh/i.test(ua) ||
    (uaChPlatform ? /macOS/i.test(uaChPlatform) : false);
  const hasTouch =
    typeof n?.maxTouchPoints === "number" && n.maxTouchPoints > 1;

  return looksLikeMac && hasTouch;
}

export function isIos(ua) {
  return /iPhone|iPod/i.test(ua) || /iPad/i.test(ua) || isIpadOs(ua);
}

export function isAndroid(ua) {
  return /Android/i.test(ua);
}
